import React from "react";
import StreamAction from "../../../svg/StreamAction";
import StreamLine from "./../StreamLine";
import "./styles.css";
import { config } from "../../../config";

const EmptyStream = ({ index }) => (
  <div className={`streams-table-item streams-table-item-opened`}>
    <div className="streams-table-item-first" />
    <div
      className="streams-table-item-second"
      style={{
        backgroundColor: "#000"
      }}
    >
      <StreamLine lineIndex={index} />
      <div className="streams-table-item-second-actions">
        <span
          className="streams-table-item-stream-number"
          style={{
            color: "#aaa"
          }}
        >
          <div className="streams-table-item-stream-number-tint">
            {config.streams.title}
            <div
              className="stream-item-number-circle"
              style={{
                color: "#4E5F8D"
              }}
            >
              {index + 1}
            </div>
          </div>
        </span>
      </div>
    </div>
    <div className="streams-table-item-stream-action" style={{ opacity: 0.5 }}>
      <div className="stream-info-wrapper">{config.streams.info}</div>
    </div>
  </div>
);
export default React.memo(EmptyStream);
